import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { CHECKOUT_URL, goToCheckout } from '../utils/tracking';
type CTAButtonProps = {
  label: string;
  location: string;
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
};
const sizes = {
  sm: 'min-h-[44px] rounded-[14px] px-4 text-sm',
  md: 'min-h-[52px] rounded-2xl px-6 text-[15px] sm:text-base',
  lg: 'min-h-[60px] rounded-2xl px-4 text-[14px] min-[400px]:text-[15px] sm:px-8 sm:text-lg'
};

/** Todos los CTA de compra comparten la clase "cta-checkout" para tracking. */
export function CTAButton({
  label,
  location,
  size = 'lg',
  fullWidth = false,
  className
}: CTAButtonProps) {
  return <a href={CHECKOUT_URL || '#oferta'} data-cta="checkout" data-cta-location={location} onClick={e => {
    e.preventDefault();
    goToCheckout(location);
  }} className={twMerge('cta-checkout group inline-flex items-center justify-center gap-2 text-center leading-tight sm:whitespace-nowrap bg-pink font-display font-extrabold uppercase text-white shadow-cta transition-[background-color,transform] duration-150 ease-out hover:bg-pink-dark active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink sm:tracking-[0.02em]', sizes[size], fullWidth && 'w-full', className)} data-id="element-118" data-mp="2yre1j3ox3o30">
      {label}
      {size !== 'sm' && <ArrowRightIcon aria-hidden="true" className="hidden h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-0.5 min-[400px]:block" data-id="element-119" data-mp="1w8ubquvznwh8" />}
    </a>;
}